module.exports = __webpack_public_path__ + "img/buddy_antenna-01.55e8266c.svg";